import React, { useEffect, useState } from 'react';
import '../../../../../vendors/NavigationTab.scss';
import ProfilePlaceHolder from '../../../../../../assets/image/emailPlaceHolder.svg';
import call from '../../../../../../assets/image/phone-call.svg';
import email from '../../../../../../assets/image/email.svg';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import Drawer from '../../../../../../component/Drawer';
import UserDetails from './userDetails';
import ActivityLog from './activityLog';
import { getUserById } from '../../../../../../services/settings/users';

function UserDrawer({ setIsOpenModal, isOpen, onClose, id, setIsEdit }) {
	const [activeTab, setActiveTab] = useState('Details');
	// const navigate = useNavigate();
	// const suburl = localStorage.getItem('suburl');
	const navTabs = ['Details', 'Activity Log'];
	const [details, setDetails] = useState({
		name: 'New User 1',
		role: 'Admin | Onwer',
		email: 'testUser1@gmail.com',
		status: 1,
		phone_number: '9089089080',
		username: 'New_user_1',
		password: '123456789',
		logged_in_date: '12/03/2025 05:20 PM',
	});

	const renderTabContent = () => {
		switch (activeTab) {
			case 'Details':
				return (
					<UserDetails
						details={details}
						type={'drawerType'}
					/>
				);
			case 'Activity Log':
				return <ActivityLog />;
			default:
				return null;
		}
	};

	async function fetchDrawerDetails() {
		try {
			const user = await getUserById(id);
			setDetails(user);
		} catch (error) {
			toast.error(error.message ?? 'Something went wrong!');
		}
	}

	useEffect(() => {
		if (isOpen) {
			fetchDrawerDetails();
		}
	}, [isOpen]);

	return (
		<Drawer
			handleViewMoreDetails={() => {
				setIsOpenModal(true);
				setIsEdit(true);
				onClose();
			}}
			handleViewButton={false}
			isOpen={isOpen}
			onClose={onClose}
			title={'User Details'}
		>
			<br />

			<div
				className="d-flex"
				style={{ gap: '20px' }}
			>
				<div className="profileImage d-flex align-self-center justify-content-sm-center">
					<img
						src={ProfilePlaceHolder}
						alt=""
						style={{ width: '55px', borderRadius: '10px' }}
					/>
				</div>

				<div className="d-flex flex-column gap-3">
					<div className="fs-4 fw-semibold text-dark">{details?.name || ''}</div>
					<div className="d-flex gap-4">
						<div className="fs-5 fw-light text-dark">{details?.role.name}</div>
						<div
							className="fs-5 fw-light"
							style={{
								color: details.is_active ? '#68C230' : '#DC3545',
							}}
						>
							{details.is_active ? 'Active' : 'Inactive'}
						</div>
					</div>
				</div>
			</div>
			<br />
			<hr />
			<div className="d-flex flex-column gap-2 my-4">
				<div className="d-flex gap-1">
					<img
						src={call}
						alt=""
						style={{ width: '14px', cursor: 'pointer' }}
					/>
					<div className="fs-5 fw-light text-dark">{details.phone_number}</div>
				</div>
				<div className="d-flex gap-1">
					<img
						src={email}
						alt=""
						style={{ width: '14px', cursor: 'pointer' }}
						onClick={() => {}}
					/>
					<div className="fs-5 fw-light text-dark">{details.email}</div>
				</div>
			</div>

			{/* tabs  */}
			<div>
				<ul className="nav mb-4 mt-2">
					{navTabs.map((item, index) => (
						<li
							key={index}
							className="nav-item"
						>
							<a
								className={`nav-link ${activeTab === item && 'active'} cursur-pointer`}
								href="#"
								onClick={(e) => {
									e.preventDefault();
									setActiveTab(item);
								}}
							>
								{item}
							</a>
						</li>
					))}
				</ul>
				<hr
					style={{
						backgroundColor: '#E3E4E5',
						boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
						marginTop: '-13px',
					}}
				/>
				<div>{renderTabContent()}</div>
			</div>
		</Drawer>
	);
}

export default UserDrawer;
